module.exports = __webpack_public_path__ + "static/media/lizScene-04.f7933720.jpg";